import { render } from "./Toggle.vue?vue&type=template&id=47b09f7f&scoped=true"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=47b09f7f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b09f7f"],['__file',"resources/js/components/Toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47b09f7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47b09f7f', __exports__)) {
    console.log('reload')
    api.reload('47b09f7f', __exports__)
  }
  
  module.hot.accept("./Toggle.vue?vue&type=template&id=47b09f7f&scoped=true", () => {
    console.log('re-render')
    api.rerender('47b09f7f', render)
  })

}


export default __exports__